import React, { useState } from 'react';

function GameOver({ score, reason, onSubmitScore, onGoHome }) {
  const [name, setName] = useState('');

  const handleSubmit = () => {
    if (name.trim()) {
      onSubmitScore(name); // Submit the player's name and score
    }
  };


  console.log("Game over screen!");
  return (
    <div className="game-over">
      <h2>Game Over</h2>
      <p>Reason: {reason}</p>
      <p>Your Final Score: {score}</p>
      <div className="submit-score">
        <input
          type="text"
          placeholder="Enter your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button onClick={handleSubmit} disabled={!name.trim()}>
          Submit Score
        </button>
        <button onClick={onGoHome}>Home</button>
      </div>
    </div>
  );
}

export default GameOver;
